import { css } from 'lit';
import { errorClassName } from '../../shared/styles/form-control.styles.js';
export const textareaStyles = css `
    :host {
        display: block;
    }

    .hlx-form-control-resized {
        width: fit-content;
    }

    .hlx-textarea-form-control .hlx-form-control-label {
        display: block;
    }

    .hlx-textarea {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: start;
        position: relative;
        width: 100%;
        font-family: var(--hlx-text-font-family-sans-serif);
        font-weight: var(--hlx-text-font-weight-medium);
        letter-spacing: var(--hlx-text-letter-spacing-normal);
        vertical-align: middle;
        overflow: hidden;
        background-color: var(--hlx-input-background-color-default);
        border: solid 1px var(--hlx-input-border-color-default);
        border-radius: var(--hlx-input-border-radius-md);
        resize: both;
    }
    .hlx-textarea:hover:not(.hlx-textarea-disabled, .hlx-textarea-readonly) {
        outline: solid 2px var(--hlx-input-border-color-default);
        outline-offset: -1px;
    }
    .hlx-textarea.hlx-textarea-focused:not(.hlx-textarea-disabled) {
        border-color: var(--hlx-color-brand-default);
        outline: solid 2px var(--hlx-color-brand-default);
        outline-offset: -1px;
    }

    .hlx-form-control-autosize .hlx-textarea {
        resize: none;
    }

    .${errorClassName} .hlx-textarea {
        border: 2px solid var(--hlx-input-border-color-error);
    }
    .${errorClassName} .hlx-textarea:hover:not(.hlx-textarea-disabled) {
        outline: solid 2px var(--hlx-input-border-color-default);
        outline-offset: -2px;
    }
    .${errorClassName} .hlx-textarea.hlx-textarea-focused:not(.hlx-textarea-disabled) {
        border-color: var(--hlx-color-brand-default);
        outline: solid 2px var(--hlx-color-brand-default);
        outline-offset: -2px;
    }

    .hlx-textarea.hlx-textarea-disabled {
        background-color: var(--hlx-input-background-color-disabled);
        border-color: var(--hlx-input-border-color-default);
        cursor: not-allowed;
    }
    .hlx-textarea.hlx-textarea-disabled .hlx-textarea-control {
        color: var(--hlx-input-text-color-disabled);
    }
    .hlx-textarea.hlx-textarea-disabled .hlx-textarea-control::placeholder {
        color: var(--hlx-input-placeholder-text-color-disabled);
    }

    .hlx-textarea.hlx-textarea-readonly {
        background-color: var(--hlx-input-background-color-disabled);
        border-color: var(--hlx-input-border-color-default);
        cursor: not-allowed;
    }
    .hlx-textarea.hlx-textarea-readonly .hlx-textarea-control::placeholder {
        color: var(--hlx-input-placeholder-text-color-readonly);
    }

    .hlx-textarea-control {
        flex: 1 1 auto;
        font-family: inherit;
        font-size: var(--hlx-text-font-size-md);
        font-weight: inherit;
        line-height: var(--hlx-text-line-height-tight-1);
        height: calc(var(--hlx-input-height-md) - border-width * 2);
        width: 100%;
        min-width: 0;
        padding: 0;
        margin: 0;
        color: var(--hlx-input-text-color-default);
        border: none;
        background: inherit;
        box-shadow: none;
        -webkit-appearance: none;
        resize: none;
    }

    .hlx-textarea-control:focus {
        outline: none;
    }
    .hlx-textarea-control::placeholder {
        color: var(--hlx-input-placeholder-text-color-default);
        font-weight: var(--hlx-text-font-weight-normal);
        user-select: none;
    }

    .hlx-textarea-control-wrapper {
        display: flex;
        height: 100%;
        padding: var(--hlx-spacing-md);
        cursor: text;
    }

    .hlx-form-control-has-suffix .hlx-textarea-control-wrapper {
        padding-bottom: 0;
    }

    .hlx-textarea-suffix-divider {
        margin: 0 var(--hlx-spacing-md);
    }

    .hlx-textarea-suffix {
        display: flex;
        align-items: center;
        justify-content: end;
    }

    .hlx-textarea-form-control:not(.hlx-form-control-autosize) .hlx-textarea-suffix {
        margin-right: var(--hlx-spacing-sm);
    }

    .hlx-form-control-has-help-text .hlx-form-control-help-text {
        display: flex;
        justify-content: space-between;
    }

    .hlx-textarea-counter {
        display: none;
    }

    .hlx-form-control.hlx-form-control-has-counter .hlx-textarea-counter {
        display: block;
        margin-left: auto;
    }

    /* Should be visibly hidden, but not with display or visibility
    because otherwise screenreeders won't read it */
    .hlx-textarea-counter-alert {
        display: inline-block;
        width: 0px;
        height: 0px;
        overflow: hidden;
    }
`;
//# sourceMappingURL=textarea.styles.js.map